import { render, staticRenderFns } from "./ResultBank.vue?vue&type=template&id=702fce85&"
import script from "./ResultBank.vue?vue&type=script&lang=js&"
export * from "./ResultBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports